import React from 'react'
import Slide7 from "./slide7";

const Content = () => {
    return (
        <div className="">
            <Slide7/>
        </div>
    )
}

export default Content;